var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuperficie({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C4552;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    transform: "translate(-5.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    transform: "translate(12.909 45.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    className: "st0",
    d: "M47.4,3.9l-3.7-3.7c-0.7-0.7-1.9-0.7-2.6,0c-0.7,0.7-0.7,1.9,0,2.6l0.5,0.5h-35l0.5-0.5 C8,2.2,8,1,7.3,0.3c-0.7-0.7-1.9-0.7-2.6,0l0,0L1,3.9C0.3,4.7,0.3,5.8,1,6.5c0,0,0,0,0,0l3.7,3.7c0.7,0.7,1.9,0.7,2.6,0 C8,9.5,8,8.3,7.3,7.6l0,0L6.7,7.1h35l-0.5,0.5c-0.7,0.7-0.7,1.9,0,2.6c0.7,0.7,1.9,0.7,2.6,0l0,0l3.7-3.7 C48.2,5.8,48.2,4.7,47.4,3.9C47.5,4,47.5,4,47.4,3.9L47.4,3.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    transform: "translate(5.565 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    className: "st0",
    d: "M8.4,38.3l-0.5,0.5V6.2l0.5,0.5c0.7,0.7,1.9,0.7,2.6,0c0.7-0.7,0.7-1.9,0-2.6L7.3,0.5 c-0.7-0.7-1.9-0.7-2.6,0c0,0,0,0,0,0L1.1,4.2c-0.7,0.7-0.7,1.9,0,2.6s1.9,0.7,2.6,0l0.5-0.5v32.6l-0.5-0.5 c-0.7-0.7-1.9-0.7-2.6,0s-0.7,1.9,0,2.6l3.7,3.7c0.7,0.7,1.9,0.7,2.6,0c0,0,0,0,0,0l3.7-3.7c0.7-0.7,0.7-1.9,0-2.6 C10.2,37.6,9.1,37.6,8.4,38.3L8.4,38.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_251",
    transform: "translate(20.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    className: "st0",
    d: "M31.5,14.6h9.1V1.8c0-1-0.8-1.8-1.8-1.8h-25v14.6H23c1,0,1.8,0.8,1.8,1.8 c0,1-0.8,1.8-1.8,1.8h-9.1v5.5c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8V0H2.3c-1,0-1.8,0.8-1.8,1.8v37.7c0,1,0.8,1.8,1.8,1.8 h7.9v-9.1c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8c0,0,0,0,0,0v9.1h25c1,0,1.8-0.8,1.8-1.8V18.3h-9.1c-1,0-1.8-0.8-1.8-1.8 C29.7,15.4,30.5,14.6,31.5,14.6L31.5,14.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuperficie);
export default __webpack_public_path__ + "static/media/icon-superficie.2fb10bb22cbe6de80c6171676a003945.svg";
export { ForwardRef as ReactComponent };